import { MAX_ANMERKUNGEN, type Anmerkung, type TextAnker } from '@awf/shared';

const ZITAT_KURZ_ZEICHEN = 40;

/**
 * Eine Meldung steht dort, wo die Nutzerin gerade arbeitet: am offenen Kommentarfeld oder in
 * der Liste. Die Liste allein reicht nicht -- auf schmalen Bildschirmen steht sie unter dem
 * ganzen Text. Die dritte, urspruenglich vorgesehene Variante (`ort: 'abschnitt'`, eine
 * Meldung direkt am Abschnitt) erzeugt `freigabe-page.tsx` seit der Umstellung auf
 * `TextFlaeche` (Task 14) nicht mehr -- die zugehoerige Anzeigelogik (`anzeigeortFuer`) ist
 * mit ihr zusammen entfernt (Task 16, R16-4).
 */
export type AnmerkungsFehler = { text: string; ort: 'feld' | 'liste' };

/**
 * Eine Anmerkung gilt, solange ihr Zitat unveraendert an ihren Offsets steht. Mehr braucht es
 * nicht: Der Redakteur darf im selben Durchgang auch bearbeiten, und eine Bearbeitung, die
 * die Stelle verschiebt oder ueberschreibt, faellt hier auf -- ohne ein zusaetzliches Feld
 * und ohne erneute Textsuche.
 */
export function istGueltig(anmerkung: Anmerkung, abschnittstext: string): boolean {
  const { von, bis, zitat } = anmerkung.anker;
  if (bis > abschnittstext.length) return false;
  return abschnittstext.slice(von, bis) === zitat;
}

export function ungueltigeAnmerkungen(
  anmerkungen: readonly Anmerkung[],
  textJeAbschnitt: ReadonlyMap<string, string>,
): Anmerkung[] {
  return anmerkungen.filter((a) => {
    const text = textJeAbschnitt.get(a.anker.abschnittId);
    return text === undefined || !istGueltig(a, text);
  });
}

export function kannHinzufuegen(anmerkungen: readonly Anmerkung[]): boolean {
  return anmerkungen.length < MAX_ANMERKUNGEN;
}

/** Die Freigabeseite setzt Anmerkungen nur fuer die Redaktion (Spec E7). */
export function neueAnmerkung(anker: TextAnker, kommentar: string): Anmerkung {
  return { anker, kommentar, herkunft: 'redakteur' };
}

export function kurzesZitat(zitat: string): string {
  return zitat.length > ZITAT_KURZ_ZEICHEN
    ? `${zitat.slice(0, ZITAT_KURZ_ZEICHEN).trimEnd()}…`
    : zitat;
}
